import { __awaiter } from 'tslib';
import { load } from 'recaptcha-v3';
import env from './env.js';

let recaptchaInstance;
let creatorsRecaptchaInstance;
const getRecaptchaToken = (action) => __awaiter(void 0, void 0, void 0, function* () {
    if (recaptchaInstance) {
        // to ensure token is fine
        return recaptchaInstance
            .execute(action)
            .catch(() => {
            // this.postWebFail({ reason: 'recaptcha - execution fail' }).then(() => {})
            recaptchaInstance === null || recaptchaInstance === void 0 ? void 0 : recaptchaInstance.execute(action);
        })
            .catch(() => {
            // this.postWebFail({ reason: 'recaptcha - execution fail' }).then(() => {})
            recaptchaInstance === null || recaptchaInstance === void 0 ? void 0 : recaptchaInstance.execute(action);
        });
    }
    // Try to load ReCaptcha three times from google CDN or load it from Anghami CDN
    recaptchaInstance = (yield load(env.RECAPTCHA_KEY, {
        autoHideBadge: true
    })
        .catch(() => {
        // this.postWebFail({ reason: 'recaptcha - load fail' }).then(() => {})
        load(env.RECAPTCHA_KEY, {
            autoHideBadge: true
        });
    })
        .catch(() => {
        // this.postWebFail({ reason: 'recaptcha - load fail' }).then(() => {})
        load(env.RECAPTCHA_KEY, {
            autoHideBadge: true
        });
    })
        .catch(() => {
        // this.postWebFail({ reason: 'recaptcha - load fail' }).then(() => {})
        load(env.RECAPTCHA_KEY, {
            autoHideBadge: true,
            customUrl: env.RECAPTCHA_CDN_URL
        });
    })
        .catch(() => {
        // this.postWebFail({ reason: 'recaptcha - load from alternative CDN fail' }).then(() => {})
        load(env.RECAPTCHA_KEY, {
            autoHideBadge: true,
            customUrl: env.RECAPTCHA_CDN_URL_ALT
        });
    }));
    // to ensure getting a token
    const token = recaptchaInstance
        .execute(action)
        .catch(() => {
        recaptchaInstance.execute(action);
        // this.postWebFail({ reason: 'recaptcha - execution fail' }).then(() => {})
    })
        .catch(() => {
        recaptchaInstance.execute(action);
        // this.postWebFail({ reason: 'recaptcha - execution fail' }).then(() => {})
    });
    return token;
});
const getCreatorsRecaptchaToken = (action) => __awaiter(void 0, void 0, void 0, function* () {
    if (creatorsRecaptchaInstance) {
        // to ensure token is fine
        return creatorsRecaptchaInstance
            .execute(action)
            .catch(() => {
            // this.postWebFail({ reason: 'recaptcha - execution fail' }).then(() => {})
            creatorsRecaptchaInstance === null || creatorsRecaptchaInstance === void 0 ? void 0 : creatorsRecaptchaInstance.execute(action);
        })
            .catch(() => {
            // this.postWebFail({ reason: 'recaptcha - execution fail' }).then(() => {})
            creatorsRecaptchaInstance === null || creatorsRecaptchaInstance === void 0 ? void 0 : creatorsRecaptchaInstance.execute(action);
        });
    }
    // Try to load ReCaptcha three times from google CDN or load it from Anghami CDN
    creatorsRecaptchaInstance = (yield load(env.CREATORS_RECAPTCHA_KEY, {
        autoHideBadge: true
    })
        .catch(() => {
        // this.postWebFail({ reason: 'recaptcha - load fail' }).then(() => {})
        load(env.CREATORS_RECAPTCHA_KEY, {
            autoHideBadge: true
        });
    })
        .catch(() => {
        // this.postWebFail({ reason: 'recaptcha - load fail' }).then(() => {})
        load(env.CREATORS_RECAPTCHA_KEY, {
            autoHideBadge: true
        });
    })
        .catch(() => {
        // this.postWebFail({ reason: 'recaptcha - load fail' }).then(() => {})
        load(env.CREATORS_RECAPTCHA_KEY, {
            autoHideBadge: true,
            customUrl: env.RECAPTCHA_CDN_URL
        });
    })
        .catch(() => {
        // this.postWebFail({ reason: 'recaptcha - load from alternative CDN fail' }).then(() => {})
        load(env.CREATORS_RECAPTCHA_KEY, {
            autoHideBadge: true,
            customUrl: env.RECAPTCHA_CDN_URL_ALT
        });
    }));
    // to ensure getting a token
    const token = creatorsRecaptchaInstance
        .execute(action)
        .catch(() => {
        creatorsRecaptchaInstance.execute(action);
        // this.postWebFail({ reason: 'recaptcha - execution fail' }).then(() => {})
    })
        .catch(() => {
        creatorsRecaptchaInstance.execute(action);
        // this.postWebFail({ reason: 'recaptcha - execution fail' }).then(() => {})
    });
    return token;
});

export { getCreatorsRecaptchaToken, getRecaptchaToken };
//# sourceMappingURL=recaptcha.js.map
